<template>
  <gv-tooltip
    :floating-ui-options="{
      placement: 'bottom',
    }"
    class="h-8"
    :label="tooltip"
  >
    <button
      class="rounded border-[0.5px] px-1"
      :class="selected ? 'bg-primary-400 border-indigo-500' : 'bg-transparent border-transparent'"
      :aria-pressed="selected"
      @click="onSelected()"
    >
      <slot :selected="selected" />
    </button>
  </gv-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { MapMode, useHazardsStore, useMapStore } from '@/features';

const hazardsStore = useHazardsStore();
const mapStore = useMapStore();

const props = defineProps<{
  mapMode: MapMode;
  tooltip?: string;
}>();

const selected = computed<boolean>(() => hazardsStore.mapMode === props.mapMode);

const onSelected = () => {
  if (hazardsStore.mapMode === props.mapMode) {
    hazardsStore.setMapMode(MapMode.Default);
  } else {
    hazardsStore.setMapMode(props.mapMode);
  }
  mapStore.closePopup();
};
</script>
